"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutCms = void 0;
var PaymentDetailsPanel_cms_1 = require("./PaymentDetailsPanel.cms");
var CommonFields_cms_1 = require("./CommonFields.cms");
var CheckoutCms = /** @class */ (function () {
    function CheckoutCms() {
        this.commonFields = new CommonFields_cms_1.CommonFieldsCms();
        this.dueTodayPanel = new PaymentDetailsPanel_cms_1.PaymentDetailsPanel();
    }
    CheckoutCms.prototype.cmstransformer = function (obj) {
        return obj.checkout;
    };
    return CheckoutCms;
}());
exports.CheckoutCms = CheckoutCms;
//# sourceMappingURL=Checkout.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/cms/Checkout.cms.js
// module id = 417
// module chunks = 8